import { useEffect } from "react";
import { DateTime } from "luxon";

import { useUserInviteSend } from "../../../hooks/useUser";

import { Alert, Button, Grid, Paper, Text, TypographyStylesProvider } from "@mantine/core";
import { FaEnvelope, FaExclamationCircle } from "react-icons/fa";
import { InviteProps } from "types/module/User/Onboarding";

const Invite: React.FC<InviteProps> = ({
  user,
  isSubmitting,
  setIsSubmitting,
  setOnboardStep,
  restartSteps,
}) => {
  const {
    mutate: userInviteSendMutate,
    data: userInviteSendData,
    isSuccess: userInviteSendSuccess,
    isError: userInviteSendError,
    error: userInviteError,
  } = useUserInviteSend();

  const handleInviteSend = () => {
    setIsSubmitting(true);

    // @ts-ignore todo: for hooks ts migration
    userInviteSendMutate({
      email: user.email,
      name: user.firstName + " " + user.lastName,
      invitationId: user.invitationId,
    });
  };

  useEffect(() => {
    if (userInviteSendSuccess || userInviteSendError) {
      if (userInviteSendSuccess && userInviteSendData) {
        setOnboardStep("INVITE_SENT");
      }
      setIsSubmitting(false);
    }
  }, [userInviteSendSuccess, userInviteSendError]);

  return (
    <Paper withBorder shadow="md" p={30} mt={30} radius="md">
      <Grid>
        <Grid.Col>
          <Text component="div" ta="center" size="lg">
            <b>
              An invitation was sent to {user.firstName} on {DateTime.fromISO(user.invitationDate).toLocaleString(DateTime.DATE_MED)}
              {' '}but they have yet to accept it. Would you like to resend?
            </b>
          </Text>
          {userInviteSendError && (
            <Alert color="red" icon={<FaExclamationCircle />} mt="md" mb="sm">
              <TypographyStylesProvider>
                <div
                  dangerouslySetInnerHTML={{
                    __html: userInviteError?.response?.data?.message,
                  }}
                />
              </TypographyStylesProvider>
            </Alert>
          )}
        </Grid.Col>
        <Grid.Col span={{ md: 8 }}>
          <Button
            onClick={handleInviteSend}
            loading={isSubmitting}
            disabled={isSubmitting}
            rightSection={<FaEnvelope size={14} />}
            fullWidth
          >
            Resend
          </Button>
        </Grid.Col>
        <Grid.Col span={{ md: 4 }}>
          <Button
            onClick={restartSteps}
            variant="default"
            disabled={isSubmitting}
            fullWidth
          >
            Cancel
          </Button>
        </Grid.Col>
      </Grid>
    </Paper>
  );
};

export default Invite;
